<template>
    <div class="text-center"
        :class="customClass">
        <div class="flex flex-row font-main-regular text-white text-sm leading-normal">
            <span class="mr-6"
                @click="switchLang(1033)"
                :class="isActive(1033)">
                {{lbl.lang.eng}}
            </span>
            <span
                @click="switchLang(1054)"
                :class="isActive(1054)">
                {{lbl.lang.thai}}
            </span>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
export default {
    name: "LangSwitcher",
    mixins: [LocaleMixin],
    props: {
        customClass: String
    },
    methods: {
        isActive: function(localCode){
            if(this.localeCode == localCode){
                this.setTracking(localCode);
                return 'underline';
            }
        },
        setTracking: function(localCode){
            let trackCategory = 'change_language';
            let trackAction = localCode == 1033 ? 'click_language_eng' : 'click_language_th';
            this.tracking.event(trackCategory, trackAction, null, null);
        }
    }
}
</script>
